export const setFavInstr = ({
  option,
  instrument,
  symbol,
  exchange,
  securityType,
  data,
  updateSelectedTitle,
}) => {
  let updatedTitle = {};

  const updatedData = data.map((element) => {
    if (
      element.instrument === instrument &&
      element.symbol === symbol &&
      element.exchange === exchange &&
      element.securityType === securityType
    ) {
      if (option === 'I') {
        element.isFavourite = 'Y';
      } else {
        element.isFavourite = 'N';
      }

      updatedTitle = element;
    }

    return element;
  });

  if (updateSelectedTitle)
    return {
      updatedTitle,
      updatedData,
    };

  return {
    updatedData,
  };
};
